import { render, staticRenderFns } from "./ProdutoArquivoUpload.vue?vue&type=template&id=95b9dad6"
import script from "./ProdutoArquivoUpload.vue?vue&type=script&lang=js"
export * from "./ProdutoArquivoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports